import * as React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Avatar,
  Button as LoadingButton,
  CssBaseline,
  TextField,
  Typography,
  IconButton,
  InputAdornment,
  Paper,
  Box,
  Grid,
  // CircularProgress,
  Stack,
} from "@mui/material";
import { Visibility, VisibilityOff, Lock } from "@mui/icons-material";
import { Login, SetUser } from "../../redux/actions/usuario";
import { getUserCargando, getUserError } from "../../redux/selectors";
import Locomotora from "../../assets/loc.jpg";

const Ingreso = () => {
  const dispatch = useDispatch();
  const [usuario, setUsuario] = React.useState("");
  const [pass, setPass] = React.useState("");
  const [showPassword, setShowPassword] = React.useState(false);
  const error = useSelector((state) => getUserError(state));
  const loading = useSelector((state) => getUserCargando(state));

  React.useEffect(() => {
    if (
      localStorage.getItem("novedades") &&
      localStorage.getItem("novedades") !== "" &&
      localStorage.getItem("novedades") !== "undefined"
    ) {
      dispatch(SetUser());
    }
  }, [dispatch]);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      login();
    }
  };
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const login = () => {
    dispatch(Login({ userName: usuario, password: pass }));
  };
  return (
    <Grid
      container
      component="main"
      sx={{
        height: "100vh",
      }}
    >
      <CssBaseline />
      <Grid
        size={{ xs: false, sm: 4, md: 8 }}
        sx={{
          backgroundImage: `url(${Locomotora})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <Grid
        size={{ xs: 12, sm: 8, md: 4 }}
        component={Paper}
        elevation={6}
        square
      >
        <Stack
          direction="column"
          sx={{
            m: (theme) => theme.spacing(8, 4),
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              height: "100px",
              fontSize: "26px",
              color: (theme) => theme.palette.grey[600],
            }}
          >
            Administración de novedades
          </Typography>
          <Avatar
            sx={{
              m: 1,
              backgroundColor: (theme) => theme.palette.secondary.main,
              color: (theme) => theme.palette.secondary.contrastText,
            }}
          >
            <Lock />
          </Avatar>
          <form
            sx={{
              width: "100%", // Fix IE 11 issue.
              mt: 1,
            }}
            noValidate
          >
            <TextField
              error={error !== ""}
              helperText={error}
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="user"
              label="Sigla / Usuario"
              name="user"
              autoComplete="user"
              onChange={(event) => setUsuario(event.target.value)}
              autoFocus
              slotProps={{
                htmlInput: {
                  sx: { textTransform: "uppercase" },
                },
              }}
            />
            <TextField
              error={error !== ""}
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="pass"
              label="Contraseña"
              type={showPassword ? "text" : "password"}
              id="pass"
              autoComplete="pass"
              onChange={(event) => setPass(event.target.value)}
              onKeyDown={handleKeyDown}
              slotProps={{
                input: {
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        edge="end"
                        aria-label="Ver contraseña"
                        onClick={() =>
                          showPassword
                            ? setShowPassword(false)
                            : setShowPassword(true)
                        }
                        onMouseDown={handleMouseDownPassword}
                      >
                        {showPassword ? <Visibility /> : <VisibilityOff />}
                      </IconButton>
                    </InputAdornment>
                  ),
                },
              }}
            />
            <Stack
              sx={{
                m: 1,
                position: "relative",
              }}
            >
              <LoadingButton
                type="button"
                fullWidth
                variant="contained"
                color="primary"
                onClick={login}
                loading={loading}
                sx={{
                  m: (theme) => theme.spacing(5, 0, 7),
                }}
                disabled={loading}
              >
                Ingresar
              </LoadingButton>
            </Stack>
          </form>
          <Box mt={5}>
            <Typography variant="body2" color="textSecondary" align="center">
              {"Realizado por FerroExpreso Pampeano TEC"}
            </Typography>
          </Box>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default Ingreso;
